import React from 'react';

interface UploadResult {
  success: boolean;
  imported?: number;
  error?: string;
}

interface UploadSectionProps {
  uploadFile: File | null;
  uploading: boolean;
  uploadResult: UploadResult | null;
  onFileChange: (file: File | null) => void;
  onUpload: () => void;
}

const UploadSection: React.FC<UploadSectionProps> = ({
  uploadFile,
  uploading,
  uploadResult,
  onFileChange,
  onUpload,
}) => {
  const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      onFileChange(e.target.files[0]);
    }
  };

  return (
    <section className="upload-card">
      <h3>📁 Importer des invités</h3>
      <p className="section-description">
        Format Excel/CSV avec colonnes Prénom, Nom, et une colonne par événement
      </p>

      <div className="upload-controls">
        <div className="file-input-wrapper">
          <input
            type="file"
            id="file-upload"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileInputChange}
          />
          <label htmlFor="file-upload" className="modern-btn secondary">
            {uploadFile ? uploadFile.name : 'Choisir un fichier'}
          </label>
        </div>

        {uploadFile && (
          <button onClick={onUpload} disabled={uploading} className="modern-btn primary">
            {uploading ? 'Import...' : 'Importer'}
          </button>
        )}
      </div>

      {uploadResult && (
        <div className="upload-result">
          {uploadResult.success ? (
            <div className="success-banner">
              ✓ {uploadResult.imported} invité(s) importé(s)
            </div>
          ) : (
            <div className="error-banner">{uploadResult.error}</div>
          )}
        </div>
      )}
    </section>
  );
};

export default UploadSection;
